import React, { useEffect, useState } from "react";
import { Controller, FormProvider, useFormContext } from "react-hook-form";
import { formConfig } from "./formConfig";
import { ColorPicker } from "./ColorPicker";
import DimensionPicker from "./DimensionPicker";
import SingleDimensionPicker from "./SingleDimensionPicker";
import { ShapePicker } from "./ShapePicker";
import { MaterialPicker } from "./MaterialPicker";
import { LuShoppingCart } from "react-icons/lu";
import { MdAddShoppingCart } from "react-icons/md";
import { YesNoPicker } from "./YesNoPicker";
import FixedValuePicker from "./FixedValuePicker";

export const DynamicForm = ({ add_order, orders, openBasket }) => {
  const { register, handleSubmit,  control, reset } = useFormContext({
    defaultValues: {
      FRAME_COLOR: "RAL 9016",
      DIMENSION: {HEIGHT: 500, WIDTH: 500}
    },
  });

  console.log("rerender dynamicform");
  const onError = (errors) => {
    console.log("Form errors:", errors);
    //console.log("Form State Errors:", formState);
  };

  const onSubmit = (data) => {
    console.log("Form Data:", data);
    //console.log(formState.errors);
    add_order(data);
    //Reset form
    reset({
      DIMENSION: {HEIGHT: 1500, WIDTH: 700}
    })

    /* nog uitbreiden met kleur en gaastype vast te zetten:
    ({
  fieldName: "new value", // Specificeer de nieuwe waarde
});

*/
  };

  return (
    <>
      {/* Shopping basket button - commented out for now
      <button
        onClick={openBasket}
        type="button"
        className="absolute z-50 top-0 right-0 m-4 inline-flex items-center p-3 text-sm font-medium text-center text-gray-700 bg-white/90 rounded-2xl hover:bg-white hover:shadow-xl hover:scale-105 focus:ring-4 focus:outline-none focus:ring-gray-200 shadow-lg transition-all duration-200 backdrop-blur-xl border border-white/40"
        style={{
          backdropFilter: 'blur(20px) saturate(180%)',
          WebkitBackdropFilter: 'blur(20px) saturate(180%)'
        }}
      >
        <LuShoppingCart className="text-gray-700 font-black text-xl" />
        <span className="sr-only">Notifications</span>
        <div className="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-gray-900 border-2 border-white rounded-full -top-2 -end-2 shadow-md">
          {orders.length}
        </div>
      </button>
      */}

      <div className="p-4 overflow-y-auto">
        <div className="mb-4">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight" style={{ fontWeight: 600 }}>
            Carport Op Maat
          </h1>
          <p className="text-gray-600 text-sm mt-2 font-normal">Configureer uw ideale carport</p>
        </div>

        <form onSubmit={handleSubmit(onSubmit, onError)} className="space-y-2.5">
          {formConfig.map((con) => {
            switch (con.type) {
              case "colorPicker":
                return (
                  <Controller
                  key={con.name}
                    name={con.name}
                    control={control}
                    rules={{ required: "Colorrrrr is required" }}
                    defaultValue={con.defaultValue}
                    render={({ field, fieldState }) => (
                      <ColorPicker
                        key={con.name}
                        name={con.name}
                        label={con.label}
                        options={con.options}
                        //errors={"test"}
                        errors={fieldState?.error}
                        selectedColor={field.value}
                        //errors={errors[con.name]}
                        title={con.title}
                        detailed_label={con.detailed_label}
                        validation={con.validation}
                        description={con.description}
                      />
                    )}
                  />
                );
                

              case "shapePicker":
                return (
                  <Controller
                  key={con.name}

                  name={con.name}
                  control={control}
                  defaultValue={con.defaultValue}
                  render={({ field, fieldState }) => (
                  <ShapePicker
                    key={con.name}
                    name={con.name}
                    label={con.label}
                    options={con.options}
                    selectedColor={field.value}
                    title={con.title}
                    detailed_label={con.detailed_label}
                    validation={con.validation}
                    errors={fieldState?.error}

                  />
                )}
                />
                );

              case "dimensionPicker":
                return (
                  <Controller
                  key={con.name}

                  name={con.name}
                  control={control}
                  defaultValue={con.defaultValue || {WIDTH: '700', HEIGHT: '1500'}}

                  render={({ field, fieldState }) => (

                  <DimensionPicker
                    validation={con.validation}
                    title={con.title}
                    detailed_label={con.detailed_label}
                    key={con.name}
                    name={con.name}
                    label={con.label}
                    fields={con.fields}
                    defaultValue={con.defaultValue}
                    displayUnit={con.displayUnit}
                    conversionFactor={con.conversionFactor}
                    errors={fieldState?.error}

                  />
                  )}/>
                );

              case "singleDimensionPicker":
                return (
                  <Controller
                  key={con.name}
                  name={con.name}
                  control={control}
                  defaultValue={con.defaultValue || ''}
                  render={({ field, fieldState }) => (
                  <SingleDimensionPicker
                    validation={con.validation}
                    title={con.title}
                    detailed_label={con.detailed_label}
                    key={con.name}
                    name={con.name}
                    label={con.label}
                    field={con.field}
                    defaultValue={con.defaultValue}
                    displayUnit={con.displayUnit}
                    conversionFactor={con.conversionFactor}
                    errors={fieldState?.error}
                  />
                  )}/>
                );

              case "materialPicker":
                return (
                  <Controller
                  key={con.name}
                  name={con.name}
                  control={control}
                  defaultValue={con.defaultValue}
                  render={({ field, fieldState }) => (
                  <MaterialPicker
                    validation={con.validation}
                    title={con.title}
                    detailed_label={con.detailed_label}
                    key={con.name}
                    name={con.name}
                    label={con.label}
                    options={con.options}
                    selectedMaterial={field.value}
                    errors={fieldState?.error}
                    description={con.description}
                  />
                  )}/>
                );

              case "yesnoPicker":
                return (
                  <Controller
                  key={con.name}

                  name={con.name}
                  control={control}
                  render={({ f, fieldState }) => (
                  <YesNoPicker
                    validation={con.validation}
                    title={con.title}
                    detailed_label={con.detailed_label}
                    key={con.name}
                    name={con.name}
                    errors={fieldState?.error}
                    label={con.label}
                  />
                )}
                />

                );

              case "fixedValuePicker":
                return (
                  <Controller
                  key={con.name}
                  name={con.name}
                  control={control}
                  defaultValue={con.defaultValue || con.min || 0}
                  render={({ field, fieldState }) => (
                  <FixedValuePicker
                    validation={con.validation}
                    title={con.title}
                    detailed_label={con.detailed_label}
                    key={con.name}
                    name={con.name}
                    label={con.label}
                    defaultValue={con.defaultValue}
                    min={con.min}
                    max={con.max}
                    step={con.step}
                    unit={con.unit}
                    displayUnit={con.displayUnit}
                    conversionFactor={con.conversionFactor}
                    errors={fieldState?.error}
                    description={con.description}
                  />
                  )}/>
                );

              case "text":
                return (
                  <div key={con.name}>
                    <label
                      htmlFor={con.name}
                      className="block text-sm font-medium"
                    >
                      {con.label}
                    </label>
                    <input
                      type="text"
                      id={con.name}
                      {...register(con.name, con.validation)}
                      className="w-full border rounded p-2"
                      placeholder={con.placeholder}
                    />
                  </div>
                );

              case "number":
                return (
                  <div key={con.name}>
                    <label
                      htmlFor={con.name}
                      className="block text-sm font-medium"
                    >
                      {con.label}
                    </label>
                    <input
                      type="number"
                      id={con.name}
                      {...register(con.name, con.validation)}
                      className="w-full border rounded p-2"
                      placeholder={con.placeholder}
                    />
                  </div>
                );

              case "checkbox":
                return (
                  <div key={con.name} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      id={con.name}
                      {...register(con.name, con.validation)}
                      className="rounded border-gray-300"
                    />
                    <label htmlFor={con.name} className="text-sm font-medium">
                      {con.label}
                    </label>
                  </div>
                );

              default:
                return null;
            }
          })}

{/*
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-3 mt-3">
            <div className="flex justify-between items-end gap-3">
              <div className="flex-1">
                <label
                  htmlFor="aantal"
                  className="block mb-2 text-sm font-semibold text-gray-700 dark:text-gray-300"
                >
                  Aantal
                </label>
                <input
                  type="number"
                  defaultValue={1}
                  id="aantal"
                  {...register("AANTAL")}
                  className="bg-gray-50 border-2 border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white transition-all duration-200"
                  placeholder="1"
                  min="1"
                />
              </div>
              <button
                type="submit"
                className="text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-semibold rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 shadow-lg transition-all duration-200 hover:shadow-xl"
              >
                <MdAddShoppingCart className="text-white font-black text-lg mr-1" />
                Voeg toe
              </button>
            </div>
          </div>
          */}

        </form>
      </div>
    </>
  );
};
